'use client';

import {Box, styled} from '@mui/material';

export const StyledCtaItemRoot = styled(Box)(({theme}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
  width: '100%',
  height: 96,
  borderRadius: theme.shape.borderRadiusMd,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.white,
  border: `1px solid ${theme.palette.background.grey}`,
  cursor: 'pointer',
  color: theme.palette.text.dark,
  transition: 'box-shadow 200ms ease, border-color 200ms ease',
  '&:hover, &:focus-within': {
    boxShadow: '0 4px 14px rgba(0,0,0,0.08)',
    borderColor: theme.palette.background.darkGrey,
  },
  '& .bread': {
    color: theme.palette.text.dark,
    margin: 0,
    marginTop: 0,
    opacity: 0,
    maxHeight: 0,
    transition: 'max-height 350ms ease, opacity 250ms ease, margin-top 250ms ease',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  '&.has-bread:hover .bread, &.has-bread:focus-within .bread': {
    opacity: 1,
    maxHeight: 60,
    marginTop: theme.spacing(0.25),
  },
}));

export const StyledCtaItemImageBox = styled(Box)(({theme}) => ({
  position: 'relative',
  flexShrink: 0,
  width: 96,
  alignSelf: 'stretch',
  margin: theme.spacing(1.25, 1.5),
  backgroundColor: theme.palette.background.lightGrey,
}));

export const StyledCtaItemContent = styled(Box)(({theme}) => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(1.25, 1.5),
  paddingRight: theme.spacing(5),
  '& .heading': {
    color: theme.palette.text.dark,
    margin: 0,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflowWrap: 'anywhere',
  },
}));

export const StyledCtaItemArrow = styled(Box)(({theme}) => ({
  position: 'absolute',
  right: theme.spacing(1.5),
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
  color: theme.palette.text.dark,
}));
